import { createAsyncThunk } from '@reduxjs/toolkit';
import authApi from '~/apis/auth';
import { FORGOT_PASSWORD, LOGIN, NEW_PASSWORD, VERIFY_CODE } from '~/utils/constants/actionType';
import { IBodyNewPassword, IFormForgotPassword, IFormLogin } from '~/utils/interface/auth';
import { IBodyVerifyCode } from '~/utils/interface/verifyCode';

export const handleLogin = createAsyncThunk(LOGIN, async (payload: IFormLogin, { rejectWithValue }) => {
  try {
    const resp = await authApi.login(payload);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const forgotPassword = createAsyncThunk(
  FORGOT_PASSWORD,
  async (payload: IFormForgotPassword, { rejectWithValue }) => {
    try {
      const resp = await authApi.forgotPassword(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const verifyCode = createAsyncThunk(VERIFY_CODE, async (payload: IBodyVerifyCode, { rejectWithValue }) => {
  try {
    const resp = await authApi.verifyCode(payload);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createNewPassword = createAsyncThunk(
  NEW_PASSWORD,
  async (payload: IBodyNewPassword, { rejectWithValue }) => {
    try {
      const resp = await authApi.createNewPassword(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
